<!-- 二维码后端导航栏 -->
<template>
  <header class="navbar navbar-fixed">
    <el-menu theme="light" mode="horizontal" :router="openRoute">
      <el-submenu class="visible-xs hidden-sm hidden-md hidden-lg pull-left icon-sub-menu" index="sub1">
        <template slot="title">
          <i class="el-icon-menu icon-nav-menu"></i>
        </template>
        <!-- <el-menu-item index='/qrgenerate'>二维码生成</el-menu-item> -->
      <el-menu-item  index='/qrgenerate/url'>网址二维码生成</el-menu-item>
      <el-menu-item  index='/qrgenerate/text'>文本二维码生成</el-menu-item>
      <el-menu-item  index='/qrgenerate/wechat'>微信二维码生成</el-menu-item>
        <!-- <el-menu-item index='/price'>价格</el-menu-item> -->
        <el-menu-item index='/cases'>案例</el-menu-item>
        <el-menu-item index='/help'>帮助</el-menu-item>
      </el-submenu>

      <el-menu-item class="navbar-brand" index='/'>
        <img src="../../assets/img/images/1-227x76.png" class="logo" alt="美钥二维码logo">
      </el-menu-item>

              <el-submenu class='hidden-xs visible-sm visible-md visible-lg'>
          <template slot="title">二维码生成</template>
          <el-menu-item index="/qrgenerate/url">网址二维码</el-menu-item>
          <el-menu-item index="/qrgenerate/text">文本二维码</el-menu-item>
          <el-menu-item index='/qrgenerate/qrIDcard'>名片二维码</el-menu-item>
          <el-menu-item index='/qrgenerate/wechat'>微信二维码</el-menu-item>
        </el-submenu>
      <!-- <el-menu-item class='hidden-xs visible-sm visible-md visible-lg' index='/price'>价格</el-menu-item> -->
      <el-menu-item class='hidden-xs visible-sm visible-md visible-lg' index='/cases'>案例</el-menu-item>
      <el-menu-item class='hidden-xs visible-sm visible-md visible-lg' index='/aboutus'>关于我们</el-menu-item>
      <el-menu-item class='hidden-xs visible-sm visible-md visible-lg' index='/help'>帮助</el-menu-item>
      <template v-if="logined">
        <!--         <el-button type="primary">管理中心</el-button> -->
        <el-submenu class="hidden-xs hidden-sm visible-md visible-lg pull-right" index="sub2">
          <template slot="title">{{username}}</template>
          <el-menu-item @click="logout" index="">退出登录</el-menu-item>
        </el-submenu>
        <el-submenu class="visible-xs visible-sm hidden-md hidden-lg pull-right" index="sub3">
          <template slot="title">账户</template>
          <el-menu-item @click="logout" index="">退出登录</el-menu-item>
        </el-submenu>
        <el-button class="manageButton pull-right" @click="routerToIndex" size="small">系统首页</el-button>
      </template>
      <template v-else>
        <el-menu-item index='/user/login' class="pull-right">登录</el-menu-item>
        <el-menu-item index='/user/register' class="pull-right">注册</el-menu-item>
      </template>
    </el-menu>
  </header>
</template>


<script type="text/javascript">

// import $ from 'jquery'
import { mapGetters } from 'vuex'
import $ from 'jquery'

export default {
  name: 'frontHeaderNavigation',
  computed: {
    ...mapGetters([ 'logined', 'username' ])
  },
  data () {
    return {
      openRoute: true
    }
  },
  created () {
    document.head.querySelector('meta[name=viewport]').content = 'width=1280'
    const vm = this
    $.ajax({
      url: '/v1/user/login/status',
      type: 'GET',
      dataType: 'json'
    })
    .done(function (data) {
      if (data.data.logined) {
        // 写入用户名等信息
        vm.$store.dispatch('login', data.data.username)
      } else {
        vm.$store.dispatch('logout')
        vm.$router.push('/user/login')
      }
    })
  },
  methods: {
    // 退出登录
    logout () {
      const vm = this
      $.ajax({
        url: '/v1/user/logout',
        type: 'GET',
        dataType: 'json'
      })
      .done(function (data) {
        if (data.error === '') {
          vm.$store.dispatch('logout')
          vm.$router.push('/user/login')
        }
      })
    },
    // 视图切换到qrmanage
    routerToIndex () {
      this.$router.push('/')
    }
  }
}
</script>

<style type="text/css">
/*全局*/
.navbar .icon-sub-menu .el-submenu__icon-arrow{
  display: none;
}
</style>

<style type="text/css" scoped>
.navbar {
  background-color: hsla(0,0%,97%,.76);
  border-bottom: 1px solid #d1d4d7;
  box-shadow: 0 0 5px rgba(0,0,0,.1);
  border-radius: 0;
  padding: 0;
  margin-bottom: 0;
  width: 100%;
}

.navbar-brand{
  margin-left: 20px!important;
  padding-top:10px;
}
.logo {
  max-height: 38px;
  width: auto;
  margin-bottom: 20px;
}
.navbar-fixed {
  z-index: 1000;
  position: fixed;
  height: 60px;
}

.el-menu {
  background-color: rgba(226, 0, 0, 0);
}

.el-menu-item:hover {
  background-color: rgba(238, 241, 246, 0.16);
}

.pull-right {
  float: right!important;
  margin-right: 15px;
}

.pull-left {
  float: left!important;
  margin-left: 15px;
}

.manageButton {
  margin-right: 10px;
  margin-top: 17px;
}

/*xs 手机*/
@media (max-width: 767px) {
  .icon-nav-menu {
    font-size: 1.2em;
    vertical-align: -14%!important;
    margin-right: 0!important;
  }
  .navbar-brand{
    margin-left: 0!important;
  }
  .navbar .el-menu-item{
    padding-left: 10px;
    padding-right: 10px;
  }
  .pull-right {
    float: right!important;
    margin-right: 0px;
  }
}
</style>
